document.addEventListener("DOMContentLoaded", function() {
  let loading = false;
  const paginationSelector = ".pagination";  
  const productListSelector = ".product-list";
  const loadOffset = 300; 

  // Function to get selected size filter values
  function getSelectedSizes() {
    const urlParams = new URLSearchParams(window.location.search);
    const sizeParams = urlParams.getAll('filter.v.option.size');
    const allSizes = [];
    
    sizeParams.forEach(param => {
      if (param && param.trim() !== "") {
        try {
          const decoded = decodeURIComponent(param);
          const sizes = decoded.split(',').map(s => s.trim()).filter(s => s !== "");
          allSizes.push(...sizes);
        } catch (e) {
          const sizes = param.split(',').map(s => s.trim()).filter(s => s !== "");
          allSizes.push(...sizes);
        }
      }
    });
    
    return allSizes;
  }

  // Function to check if product has any variant with selected sizes that has inventory
  function hasAvailableSize(productCard, selectedSizes) {
    if (!selectedSizes || selectedSizes.length === 0) {
      return true; // No size filter, show all
    }

    const variantScript = productCard.querySelector('script[data-variants]');
    if (!variantScript) {
      return productCard.getAttribute('data-visible') === 'true';
    }

    try {
      const variantData = JSON.parse(variantScript.textContent);
      const variants = variantData.variants || [];
      const options = variantData.options || [];

      if (variants.length === 0) {
        return productCard.getAttribute('data-visible') === 'true';
      }

      // Find the size option position
      let sizeOptionPosition = null;
      for (let i = 0; i < options.length; i++) {
        const optionName = (options[i].name || '').toLowerCase();
        if (optionName === 'size' || optionName.includes('size')) {
          sizeOptionPosition = options[i].position || (i + 1);
          break;
        }
      }

      if (sizeOptionPosition === null) {
        return productCard.getAttribute('data-visible') === 'true';
      }

      // Normalize selected sizes for comparison
      const normalizedSelectedSizes = selectedSizes.map(size => {
        try {
          return decodeURIComponent(size).toLowerCase().trim();
        } catch (e) {
          return size.toLowerCase().trim();
        }
      });

      // Check if ANY variant matching ANY selected size has inventory
      for (let i = 0; i < variants.length; i++) {
        const variant = variants[i];
        let variantSize = null;

        // Get the size value based on position
        if (sizeOptionPosition === 1) {
          variantSize = variant.option1;
        } else if (sizeOptionPosition === 2) {
          variantSize = variant.option2;
        } else if (sizeOptionPosition === 3) {
          variantSize = variant.option3;
        }

        // Check if this variant matches ANY selected size and has inventory
        if (variantSize) {
          const variantSizeNormalized = String(variantSize).toLowerCase().trim();
          const matchesSize = normalizedSelectedSizes.some(size => size === variantSizeNormalized);
          
          if (matchesSize) {
            const inventoryQty = variant.inventory_quantity || 0;
            if (inventoryQty > 0) {
              return true; // Found a matching size with inventory
            }
          }
        }
      }

      return false; // No matching size with inventory found
    } catch (e) {
      console.error('Error parsing variant data:', e);
      return productCard.getAttribute('data-visible') === 'true';
    }
  }

  // Function to get original visibility state from variant data
  function getOriginalVisibility(productCard) {
    try {
      const script = productCard.querySelector('script[data-variants]');
      if (script) {
        const data = JSON.parse(script.textContent);
        const firstVariant = data.variants && data.variants[0];
        return firstVariant && firstVariant.inventory_quantity > 0;
      }
    } catch(e) {
      console.error('Error getting original visibility:', e);
    }
    return true; // Default to visible if can't determine
  }

  // Function to filter products based on selected sizes
  function filterProductsByQuantity() {
    const selectedSizes = getSelectedSizes();
    const products = document.querySelectorAll('product-card');
    
    console.log('Filtering products. Selected sizes:', selectedSizes);
    
    if (selectedSizes.length > 0) {
      // Size filter is active
      let visibleCount = 0;
      let hiddenCount = 0;
      
      products.forEach(product => {
        const hasSize = hasAvailableSize(product, selectedSizes);
        product.setAttribute('data-visible', hasSize ? 'true' : 'false');
        
        if (hasSize) {
          visibleCount++;
        } else {
          hiddenCount++;
        }
      });
      
      console.log(`Size filter active: ${visibleCount} visible, ${hiddenCount} hidden`);
    } else {
      // No size filter - restore original visibility
      console.log('No size filter - restoring original visibility');
      
      products.forEach(product => {
        const isVisible = getOriginalVisibility(product);
        product.setAttribute('data-visible', isVisible ? 'true' : 'false');
      });
    }
  }

  // Function to check if filters are active
  function areFiltersActive() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('filter.v.option.size') || 
           urlParams.has('filter.v.price') || 
           Array.from(urlParams.keys()).some(key => key.startsWith('filter.'));
  }

  // Function to update body class based on filter state
  function updateFilterState() {
    if (areFiltersActive()) {
      document.body.classList.add('filters-active');
    } else {
      document.body.classList.remove('filters-active');
    }
  }

  // Initial setup
  updateFilterState();
  filterProductsByQuantity();

  // Watch for DOM changes
  const observer = new MutationObserver(function(mutations) {
    updateFilterState();
    setTimeout(() => {
      filterProductsByQuantity();
    }, 100);
  });

  const collectionElement = document.querySelector('.collection');
  if (collectionElement) {
    observer.observe(collectionElement, {
      childList: true,
      subtree: true
    });
  }

  // Listen for facet updates
  document.addEventListener('facet:update', function() {
    setTimeout(() => {
      updateFilterState();
      filterProductsByQuantity();
    }, 1600);
  });

  // Listen for URL changes
  let lastUrl = window.location.href;
  const urlCheckInterval = setInterval(() => {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      lastUrl = currentUrl;
      setTimeout(() => {
        updateFilterState();
        filterProductsByQuantity();
      }, 100);
    }
  }, 100);

  window.addEventListener('popstate', function() {
    setTimeout(() => {
      updateFilterState();
      filterProductsByQuantity();
    }, 100);
  });

  // Infinite scroll logic
  window.addEventListener("scroll", function() {
    if (loading) return;
    const pagination = document.querySelector(paginationSelector);
    if (!pagination) return;

    const rect = pagination.getBoundingClientRect();
    if (rect.top - window.innerHeight < loadOffset) {
      const nextLink = pagination.querySelector("a.next"); 
      if (nextLink) {
        loading = true;
        
        fetch(nextLink.href)
          .then(resp => resp.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const newProducts = doc.querySelectorAll(productListSelector + " > product-card");
            const currentList = document.querySelector(productListSelector);
            const selectedSizes = getSelectedSizes();
            
            newProducts.forEach(productCard => {
              if (selectedSizes.length > 0) {
                // Filter by size
                if (hasAvailableSize(productCard, selectedSizes)) {
                  productCard.setAttribute('data-visible', 'true');
                  currentList.appendChild(productCard);
                } else {
                  productCard.setAttribute('data-visible', 'false');
                  currentList.appendChild(productCard);
                }
              } else {
                // No filter - use original visibility
                const isVisible = getOriginalVisibility(productCard);
                productCard.setAttribute('data-visible', isVisible ? 'true' : 'false');
                currentList.appendChild(productCard);
              }
            });
            
            const newPagination = doc.querySelector(paginationSelector);
            if (newPagination) {
              pagination.innerHTML = newPagination.innerHTML;
            } else {
              pagination.remove();
            }
          })
          .catch(error => {
            console.error('Error loading more products:', error);
          })
          .finally(() => {
            loading = false;
          });
      }
    }
  });
});